export default function CReadFiles() {
  return <h2>C Read Files</h2>;
}
